// Runtime config, loaded by the blocking <script src="/api/config"> tag in
// index.html before this module evaluates. See src/global.d.ts.
const config = window.__env__;

export enum HTTP_METHOD {
    GET = "get",
    POST = "post",
    PUT = "put",
    PATCH = "patch",
    DELETE = "delete"
}

export enum REDIRECT_ERROR_TYPE {
    unauthorized = "unauthorized"
}

export const ADMIN_ROLE: string = 'Admin';
export const SUPER_ADMIN_ROLE: string = 'SuperAdmin';
export const ADMIN_APP_NAME: string = 'admin-app';

// Seeded, system-critical roles that cannot be edited or deleted from the Roles tab.
export const SYSTEM_ROLE_NAMES: string[] = ['Admin', 'SuperAdmin', 'QlikAdmin'];

export const isSystemRole = (name: string) =>
    SYSTEM_ROLE_NAMES.some((s) => s.toLowerCase() === name.toLowerCase());

export const REACT_APP_STS_AUTHORITY: string = config.STS_AUTHORITY;
export const REACT_APP_CLIENT_ID: string = config.CLIENT_ID;
export const REACT_APP_RESPONSE_TYPE: string = config.RESPONSE_TYPE;
export const REACT_APP_CLIENT_SCOPE: string = config.CLIENT_SCOPE;
export const REACT_APP_LOGIN_URL: string = config.LOGIN_URL;
export const REACT_APP_IDENTITY_API_BASE_URL: string = config.IDENTITY_API_BASE_URL;

export const REACT_APP_SENTRY_DSN: string = config.SENTRY_DSN;
export const REACT_APP_SENTRY_ENVIRONMENT: string = config.SENTRY_ENVIRONMENT;
